<template>
  <div style="margin-top:20px;">
      <table class="att-table" cellspacing="0" style="width:100%;" v-if="showList">
        <thead>
          <tr>
            <th style="text-align:center">附件类别</th>
            <th style="text-align:center">附件名称</th>
            <th style="text-align:center">上传日期</th>
            <th style="text-align:center">上传用户</th>
            <th style="text-align:center">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item of attForm.att_list" :key="item.id">
            <td style="text-align:center">{{ item.att_category_title }}</td>
            <td style="text-align:center">{{ item.att_name }}</td>
            <td style="text-align:center">{{ item.s_create_time }}</td>
            <td style="text-align:center">{{ item.create_user }}</td>
            <td style="text-align:center">
              <Button type="text" style="color: #FF0080" @click="showAtt(item.static_url)">查看</Button>
              <Button type="text" style="color: purple" @click="delAtt(item.id)" v-if="canEdit">删除</Button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
const COMP_NAME = 'DsList'
export default {
  name: COMP_NAME,
  props: {
    attForm: {
      type: Object,
      required: true
    }
  },
  computed: {
    canEdit: function () {
      if (this.attForm.show_mode === 'R') {
        return false
      } else {
        return true
      }
    },
    showList: function () {
      if (this.$notNull(this.attForm.att_list)) {
        return true
      } else {
        return false
      }
    }
  },
  data () {
    return {
      attCategory: this.attForm.att_category_options.length === 1 ? this.attForm.att_category_options[0].value : null
    }
  },
  methods: {
    showAtt (staticUrl) {
      let baseURL = this.$store.state.common.baseURL
      let str = localStorage.getItem(this.$store.state.common.keyToken)
      var url = baseURL + staticUrl + '?Authorization=' + str
      window.open(url)
    },
    delAtt (id) {
      this.$setAuth(this.attForm.menu_code)
      this.$axios.post(this.$URLS.attDel, { id: id }).then(() => {
        this.attForm.att_list.forEach((item, index) => {
          if (item.id === id) {
            this.attForm.att_list.splice(index, 1)
          }
        })
      })
    }
  },
  mounted () {
  }
}
</script>

<style type="text/stylus" lang="stylus" rel="stylesheet/stylus">
.att-table {
  border: 1px solid rgba(0, 0, 0, 0.12);

  thead th {
    font-size: 14px;
    font-weight: 600;
    padding: 6px;
  }

  tbody tr:nth-child(2n+1) {
    background: rgba(0, 0, 0, 0.03);
  }

  tbody td {
    font-size: 14px;
    padding: 2px;
  }
}

.att-table tr th:not(:last-child), .att-table tr td:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.att-table tr th.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>



// WEBPACK FOOTER //
// src/components/dsattlist/DsList.vue